// Initialize Lottie animation
function initLottieAnimation({
    containerId,
    jsonPath,
    loop = true,
    autoplay = true,
    scrollControlled = false,
    scrollTriggerSelector = null,
}) {
    // Ensure Lottie library is loaded
    if (typeof lottie === "undefined") {
        console.error("Lottie library is not loaded.");
        return;
    }

    // Load Lottie animation
    const animation = lottie.loadAnimation({
        container: document.getElementById(containerId), // Required
        renderer: "svg",
        loop: loop,
        autoplay: autoplay,
        path: jsonPath, // Path to Lottie JSON
    });

    // If scroll-controlled, use GSAP's ScrollTrigger
    if (scrollControlled && scrollTriggerSelector) {
        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.create({
            trigger: scrollTriggerSelector,
            start: "top top",
            end: "bottom top",
            scrub: 1,
            onUpdate: (self) => {
                const frame = self.progress * (animation.totalFrames - 1);
                animation.goToAndStop(frame, true);
            },
        });
    }

    return animation; // Return the animation instance if needed
}

// Register ScrollTrigger plugin with GSAP
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", function () {
    // Initialize Lottie animation for the hero section
    initLottieAnimation({
        containerId: "lottieAnimation",
        jsonPath: "assets/lottie/geometric-ring-loader.json",
        loop: false,
        autoplay: true,
        scrollControlled: true,
        scrollTriggerSelector: ".heroSection",
    });

    // Video Background Scaling
    gsap.to(".heroBg", {
        scale: 1.3, // Slight zoom-in effect
        duration: 2,
        ease: "power1.inOut",
        scrollTrigger: {
            trigger: ".heroSection",
            start: "top top",
            end: "bottom top",
            scrub: 1, // Sync animation with scroll
        },
    });
    // Parallax effect on .heroContent
    gsap.to(".heroContent", {
        y: -280, // Adjust to control parallax strength
        ease: "power2.out",
        scrollTrigger: {
            trigger: ".heroSection",
            start: "top top",
            end: "bottom top",
            scrub: 1,
        },
    });

    // Animate .dhnHeroTitle (Title)
    gsap.from(".dhnHeroTitle", {
        y: -150,
        opacity: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
            trigger: ".heroSection",
            start: "top 80%", // Start when section enters viewport
        },
    });

    // Animate tagline (.tagLineHero) with delayed fade-in
    gsap.from(".tagLineHero", {
        y: 150,
        opacity: 0,
        duration: 1,
        delay: 0.3, // Adds a slight delay for a staggered effect
        ease: "power2.out",
        scrollTrigger: {
            trigger: ".heroSection",
            start: "top 80%",
        },
    });

    gsap.to(".testimonialContainer", {
        y: -60, // Adjust to control parallax strength
        ease: "power2.out",
        scrollTrigger: {
            trigger: ".heroSection",
            start: "top top",
            end: "bottom top",
            scrub: 1,
        },
    });
    gsap.to(".ourPartners", {
        y: -60, // Adjust to control parallax strength
        ease: "power2.out",
        scrollTrigger: {
            trigger: ".heroSection",
            start: "top top",
            end: "bottom top",
            scrub: 1,
        },
    });
});

function initLottieToggle({
    containerId,
    navId,
    jsonPath,
    frame1 = 1,
    frame2 = 49,
    speed = 1.5, // Playback speed parameter
}) {
    // Ensure Lottie library is loaded
    if (typeof lottie === "undefined") {
        console.error("Lottie library is not loaded.");
        return;
    }

    // Load the Lottie animation
    const animation = lottie.loadAnimation({
        container: document.getElementById(containerId),
        renderer: "svg",
        loop: false, // Disable looping
        autoplay: false, // Start paused
        path: jsonPath, // Path to Lottie JSON file
    });

    // Set playback speed
    animation.setSpeed(speed);

    // Set initial toggle state
    let toggleState = 0;
    const nav = document.getElementById(navId);

    // Function to toggle scroll lock
    function toggleScrollLock(lock) {
        document.body.style.overflow = lock ? "hidden" : "";
    }

    // Function to open the nav (plays animation from frame1 to frame2)
    function openNav() {
        animation.playSegments([frame1, frame2], true); // Play forward to close state
        toggleScrollLock(true); // Lock scroll
        nav.classList.add("active"); // Show nav
        toggleState = 1;
    }

    // Function to close the nav (plays animation from frame2 to frame1)
    function closeNav() {
        animation.playSegments([frame2, frame1], true); // Play in reverse to open state
        toggleScrollLock(false); // Unlock scroll
        nav.classList.remove("active"); // Hide nav
        toggleState = 0;
    }

    // Click handler to toggle animation, scroll lock, and nav visibility
    document
        .getElementById(containerId)
        .addEventListener("click", function () {
            if (toggleState === 0) {
                openNav(); // Open nav and lock scroll
            } else {
                closeNav(); // Close nav and unlock scroll
            }
        });

    // Add click event listener to each link inside nav to close nav when clicked
    const navLinks = nav.querySelectorAll("ul.navItems li a");
    navLinks.forEach((link) => {
        link.addEventListener("click", function () {
            closeNav(); // Close nav on link click
        });
    });

    return animation; // Return animation instance if needed
}

document.addEventListener("DOMContentLoaded", function () {
    initLottieToggle({
        containerId: "mobileMenuToggle",
        navId: "mainNav", // ID of the <nav> element
        jsonPath: "assets/lottie/menu.json",
        frame1: 1,
        frame2: 49,
        speed: 2, // Set playback speed to 2x
    });
});
document.addEventListener("DOMContentLoaded", function () {
    initLottieToggle({
        containerId: "mobileMenuToggle",
        navId: "mainNavLanding", // ID of the <nav> element
        jsonPath: "assets/lottie/menu.json",
        frame1: 1,
        frame2: 49,
        speed: 2, // Set playback speed to 2x
    });
});

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

function initMarquee() {
    // Create a master timeline to synchronize animations
    const masterTimeline = gsap.timeline({ repeat: -1, ease: "none" });

    // Set marquee speed in pixels per second
    const marqueeSpeed = 50; // Adjust this value to control speed

    // Select all marquee elements
    const marquees = document.querySelectorAll(
        ".marQueeToLeft, .marQueeToRight"
    );

    marquees.forEach((marquee) => {
        const direction = marquee.classList.contains("marQueeToLeft")
            ? "left"
            : "right";

        // Duplicate the content to create a seamless loop
        const originalContent = marquee.innerHTML;
        marquee.innerHTML += originalContent;

        // Get the width of the marquee content
        const distance = marquee.scrollWidth / 2; // Since content is duplicated
        const duration = distance / marqueeSpeed;

        // Create a wrapper function for seamless looping
        const wrapX = gsap.utils.wrap(-distance, 0);

        // Adjust starting and ending x positions based on direction
        const fromX = direction === "left" ? 0 : -distance;
        const toX = direction === "left" ? -distance : 0;

        // Create the animation for the marquee
        const tween = gsap.fromTo(
            marquee,
            { x: fromX },
            {
                x: toX,
                duration: duration,
                ease: "none",
                modifiers: {
                    x: (x) => wrapX(parseFloat(x)) + "px",
                },
            }
        );

        // Add the tween to the master timeline at the same start time
        masterTimeline.add(tween, 0);

        // Apply scroll-triggered parallax effect with adjustments
        gsap.to(marquee, {
            xPercent: direction === "left" ? -3 : 3, // Reduced parallax movement
            ease: "power2.out", // Adjusted easing function for smoother transition
            scrollTrigger: {
                trigger: marquee,
                start: "top bottom",
                end: "bottom top",
                scrub: 1, // Adjusted scrub value for smoother parallax
            },
        });
    });
}

// Initialize marquee animations on DOMContentLoaded
// document.addEventListener("DOMContentLoaded", function () {
//     initMarquee();
// });

// Animate the speaker elements
gsap.fromTo(
    ".speaker",
    { opacity: 0, scale: 2 },
    {
        opacity: 1,
        scale: 1,
        duration: 0.5,
        ease: "power2.out",
        stagger: {
            each: 0.2,
        },
        scrollTrigger: {
            trigger: ".speakersGrid",
            start: "top 90%",

            toggleActions: "play none none reverse",
        },
    }
);